import React, { createContext, useEffect, useState } from "react";
import { Button, Image } from "@themesberg/react-bootstrap";

import ReactLogo from "../assets/img/technologies/react-logo-transparent.svg";
import { useSelector, useDispatch } from "react-redux";
import { reset, VerifUser } from "../features/authSlice";
import { Link, Navigate } from "react-router-dom";

// Create a context
export const UserContext = createContext();

const ProtectedRoute = ({ roles, children }) => {
  const dispatch = useDispatch();
  const { data, isLoading, isError, isSuccess } = useSelector(
    (state) => state.auth
  );
  const token = localStorage.getItem("token");
  // const userData = localStorage.getItem("userData");

  useEffect(() => {
    dispatch(reset());
    dispatch(VerifUser(token));
  }, [dispatch, token]);

  const [userData, setUserData] = useState();

  useEffect(() => {
    setUserData(data?.data);
  }, [data]);

  if (isLoading) {
    // Jika verifikasi masih berlangsung, tampilkan pesan loading atau komponen loading
    return (
      <div className={`preloader bg-soft justify-content-center`}>
        <Image
          className="loader-element animate__animated animate__jackInTheBox"
          src={ReactLogo}
          height={40}
        />
      </div>
    );
  } else {
    if (isError) {
      // Jika ada kesalahan atau pengguna tidak terverifikasi, alihkan ke halaman login
      localStorage.clear();
      return <Navigate to="/" replace />;
    } else {
      if (isSuccess) {
        localStorage.setItem(
          "userData",
          JSON.stringify({ id: data?.data?.id, status: data?.data?.status })
        );
        if (JSON.parse(localStorage.getItem("userData")).status === "0") {
          return <Navigate to="/verification" replace />;
        } else if ((roles || []).length > 0) {
          const role = data?.data?.id_role;
          if (!roles.includes(role)) {
            return (
              <div
                className={`bg-soft centerAbsolute`}
              >
                <h2>Oops!, seems you were lost!</h2>
                <Button
                  as={Link}
                  variant="outline-primary"
                  size="sm"
                  to={`/`}
                >
                  Kembali
                </Button>
              </div>
            );
          }
        }
      }
    }
  }

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
};

export default ProtectedRoute;
